import { BaseService } from '../../../infra/base.service'
import { FormV2FormSignatureLogsRepository } from './form-v2-form-signature-logs.repository'
import type { FormV2FormSignatureLog } from './form-v2-form-signature-log'

export class FormV2FormSignatureLogsService extends BaseService<FormV2FormSignatureLog> {
    constructor(private rep: FormV2FormSignatureLogsRepository) {
        super(rep)
    }
}
